import { render, staticRenderFns } from "./ClientAccounts.vue?vue&type=template&id=42954196&scoped=true&"
import script from "./ClientAccounts.vue?vue&type=script&lang=js&"
export * from "./ClientAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccounts.vue?vue&type=style&index=0&id=42954196&prod&lang=scss&"
import style1 from "./ClientAccounts.vue?vue&type=style&index=1&id=42954196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42954196",
  null
  
)

export default component.exports